import { useCallback, useEffect, useState } from 'react';
import { AIR_PLUS_LANGUAGE_EVENT, getAirPlusLanguage, setAirPlusLanguage, syncAirPlusLanguage, translateAirPlus } from 'src/i18n/airPlus/language';

// Shared by student, teacher and administrator screens throughout AirPlus.
export default function useAirPlusLmsLanguage() {
  const [language, updateLanguage] = useState(getAirPlusLanguage);
  useEffect(() => {
    const sync = event => updateLanguage(syncAirPlusLanguage(event));
    window.addEventListener(AIR_PLUS_LANGUAGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(AIR_PLUS_LANGUAGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  const text = useCallback((english, korean) => language === 'ko' ? korean : english, [language]);
  const t = useCallback((value, ...values) => translateAirPlus(value, language, values), [language]);
  return { language, isKo: language === 'ko', text, t, setLanguage: setAirPlusLanguage };
}
